import { createAsyncThunk } from "@reduxjs/toolkit";
import payrollServiceApiInstance from "../../../../../../config/payrollApiConfig";
import {
  EsicReason,
  CreateEsicReasonPayload,
  UpdateEsicReasonPayload,
} from "./reasonTypes";

// Create
export const createEsicReason = createAsyncThunk<
  {
      message: string; id: number 
},
  CreateEsicReasonPayload
>("esicReason/create", async (payload, { rejectWithValue }) => {
  try {
    const response = await payrollServiceApiInstance.post("/esic-reason", payload);
    return response.data.data;
  } catch (error: any) {
    return rejectWithValue(error.response?.data || error.message);
  }
});

// Get All
export const fetchEsicReasonList = createAsyncThunk<EsicReason[]>(
  "esicReason/fetchAll",
  async (_, { rejectWithValue }) => {
    try {
      const response = await payrollServiceApiInstance.get("/esic-reason");
      return response.data.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

// Get By Id
export const fetchEsicReasonById = createAsyncThunk<EsicReason, number>(
  "esicReason/fetchById",
  async (id, { rejectWithValue }) => {
    try {
      const response = await payrollServiceApiInstance.get(`/esic-reason/${id}`);
      return response.data.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

// Update
export const updateEsicReason = createAsyncThunk<
  void,
  { id: number; payload: UpdateEsicReasonPayload }>("esicReason/update", async ({ id, payload }, { rejectWithValue }) => {
  try {
    const response = await payrollServiceApiInstance.put(`/esic-reason/${id}`, payload);
    return response.data;
  } catch (error: any) {
    return rejectWithValue(error.response?.data || error.message);
  }
});

// Delete
export const deleteEsicReason = createAsyncThunk<void, number>(
  "esicReason/delete",
  async (id, { rejectWithValue }) => {
    try {
      await payrollServiceApiInstance.delete(`/esic-reason/${id}`);
    } catch (error: any) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);
